
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password-recovery",
      function () {
        return require("private-next-pages/password-recovery/index.tsx");
      }
    ]);
  